import { styled } from "@mui/material";

const CircularImage = styled('div')(({theme, imageUrl, size}) => ({
    backgroundImage: `url(${imageUrl})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: '100%',
    borderStyle: 'solid',
    borderWidth: '0.18rem',
    borderColor: theme.palette.common.white,
    width: size,
    height: size
}))

export default CircularImage;